import root, { Type } from "src/modules/media-upload-protobuf";
import debug from "src/modules/debug-logger";
import { decodeProtocolBuffer } from "src/modules/protocol-buffers";
import { getPathForFileName } from "src/modules/activity-log/lib/fs-helpers";
import { getEnvironmentVariable } from "src/utils/environment";

import uploadData from "./uploadData";

const fs = window.require("fs");
const log = window.require("electron-log");

export default function uploadMedia(media) {
  const { fileName, type } = media;
  return new Promise(async (resolve, reject) => {
    const ws = new WebSocket(getEnvironmentVariable("MEDIA_UPLOAD_SERVER_URL"));
    let fileHandle;

    try {
      fileHandle = await fs.promises.open(getPathForFileName(fileName), "r");
    } catch (error) {
      reject(error);
      ws.close();
      return;
    }

    async function handleWebSocketClose() {
      reject("WebSocket was closed");
      try {
        fileHandle && (await fileHandle.close());
      } catch (error) {
        log.error(error);
      }
    }

    async function handleMessage(e) {
      try {
        const blob = e.data;
        const arrayBuffer = await new Response(blob).arrayBuffer();
        const uInt8Array = new Uint8Array(arrayBuffer);
        const message = decodeProtocolBuffer({
          root,
          buffer: uInt8Array,
          typePath: "upload.Message"
        });
        if (message.uploadDidPrepareMessage) {
          try {
            await uploadData({ ws, fileHandle, media });
            await fileHandle.close();
            const message = Type.Message.create({
              finishUploadMessage: Type.FinishUploadMessage.create()
            });
            ws.send(Type.Message.encode(message).finish());
          } catch (error) {
            ws.removeEventListener("close", handleWebSocketClose);
            ws.close();
            reject(error);
          }
        }
        if (message.uploadDidFinishMessage) {
          ws.removeEventListener("close", handleWebSocketClose);
          ws.close();
          resolve();
        }
        if (message.sampleFileDidUploadMessage) {
          debug.activityLog(
            "Received mp3 sample",
            message.sampleFileDidUploadMessage.signedUrl
          );
          const { signedUrl } = message.sampleFileDidUploadMessage;
          media.onSample && media.onSample(signedUrl);
        }
      } catch (error) {
        ws.removeEventListener("close", handleWebSocketClose);
        ws.close();
        reject(error);
      }
    }

    function handleWebSocketOpen() {
      const prepareUploadMessage = Type.PrepareUploadMessage.create({
        fileName,
        mediaType: Type.MediaType.values[type],
        prepareSample: media.finishedWritting ? false : Boolean(media.onSample)
      });
      const message = Type.Message.create({ prepareUploadMessage });
      ws.send(Type.Message.encode(message).finish());
    }

    ws.addEventListener("open", handleWebSocketOpen, { once: true });
    ws.addEventListener("message", handleMessage);
    ws.addEventListener("error", (error) => {
      ws.removeEventListener("close", handleWebSocketClose);
      reject(error);
      ws.close();
    });
    ws.addEventListener("close", handleWebSocketClose);
  });
}
